import React from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import DateAndHourItem from "../../../components/forms/DateAndHourItem";
import { SelectItem as SelectItemComponent } from "../../../components/forms/FormItems";
import { useSelector } from "react-redux";
import moment from "moment";

const Planning = (props) => {
  const {
    activeHouseVisit,
    changedValues,
    enabled,
    setProffesionalEmployees,
  } = props;
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const patient = activeHouseVisit.patient || activePatient;
  const professionalFilter = {
    $and: [
      {
        $or: [
          { professional_role_id: 1 },
          { professional_role_id: 2 },
          { professional_role_id: 3 },
          { professional_role_id: 4 },
          { controller: true },
        ],
      },
      { $or: [{ status: 1 }, { status: 3 }] },
    ],
  };

  const onDataChanged = (employees) => {
    setProffesionalEmployees(employees || []);
  };

  const disabledDate = (current) => {
    const isAprroved =
      changedValues["approved"] !== undefined
        ? changedValues["approved"]
        : activeHouseVisit.approved;
    return current && current > moment() && isAprroved;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.house_visits.planning" />}
        />
        <Row>
          <Col xs={24} sm={18} md={13} lg={12} xl={12} xxl={10}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <EmployeesSelect
                  name="planned_employee_id"
                  category="house_visits"
                  required={true}
                  waitForFetch={!patient || !patient.branch}
                  extraParams={{
                    filter: professionalFilter,
                    scopePrefix: patient && `branches/${patient.branch}/`,
                  }}
                  disabled={!enabled}
                  proffesional={true}
                  onDataChanged={onDataChanged}
                />
              </div>
              <div style={{ flex: 1 }} />
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", width: "max-content" }}>
                  <DateAndHourItem
                    required={true}
                    name="date"
                    category="house_visits"
                    disabledDate={disabledDate}
                    disabled={!enabled}
                  />
                  <Spacer horizontal={true} />
                  <div style={{ flex: 1, width: "120px" }}>
                    <SelectItemComponent
                      required={true}
                      name="duration_minutes"
                      category="house_visits"
                      duration={true}
                      disabled={!enabled}
                    />
                  </div>
                </div>
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default Planning;
